import React, { useState, useEffect } from 'react';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';



import Header from './components/Header';

import HeaderLogIn from './components/HeaderLogIn';



import Home from './pages/Home';

import BookReader from './pages/BookReader';

import AuthModal from './components/AuthModal';

import EmailLogin from './pages/EmailLogin';

import NewStory from './pages/NewStory';

import EditStory from './pages/EditStory';

import MyStories from './pages/MyStories';

import StoryPreview from './pages/StoryPreview';

import StoryDetails from './pages/StoryDetails';

import Dashboard from './pages/DashBoard';

import CategoryPage from './components/CategoryPage';

import Profile from './components/Profile';

import Notifications from './pages/Notifications';

import InBox from './pages/InBox';

import Library from './pages/Library';

import Book from './pages/Book';

import Settings from './components/Settings';

import Discover from './pages/Discover';

import Search from './components/Search';

import SearchResults from './pages/SearchResults';

import ResetPassword from './pages/ResetPassword';

import NewPassword from './pages/NewPassword';

import Community from './components/Community';

import Agreements from './components/Agreements';



import { WebSocketProvider } from './utils/WebSocketContext';



function AppContentWrapper() {

  const location = useLocation();



  // 📌 Scroll to top on route change

  useEffect(() => {

    window.scrollTo(0, 0);

  }, [location.pathname]);



  return <AppContent location={location} />;

}



function AppContent({ location }) {

  const [authType, setAuthType] = useState('login');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [showEmailLogin, setShowEmailLogin] = useState(false);



  const categories = [

    { id: 1, name: 'Aksiyon' },

    { id: 2, name: 'Bilim Kurgu' },

    { id: 3, name: 'Fantastik' },

    { id: 4, name: 'Genel Kurgu' },

    { id: 5, name: 'Genç Kurgu' },

    { id: 6, name: 'Gerilim' },

    { id: 7, name: 'Gizem' },

    { id: 8, name: 'Hayran Kurgu' },

    { id: 9, name: 'Klasikler' },

    { id: 10, name: 'Korku' },

    { id: 11, name: 'Kısa Hikaye' },

    { id: 12, name: 'Macera' },

    { id: 13, name: 'Mizah' },

    { id: 14, name: 'Paranormal' },

    { id: 15, name: 'Romantizm' },

    { id: 16, name: 'Spiritüel' },

    { id: 17, name: 'Tarihi Kurgu' },

    { id: 18, name: 'Texting' },

    { id: 19, name: 'Vampir' },

    { id: 20, name: 'Şiir' },

  ];



  const handleSwitchAuthType = (newType) => {

    if (newType === 'email') {

      setShowEmailLogin(true);

    } else {

      setAuthType(newType);

      setIsModalOpen(true);

    }

  };



  const handleCloseModal = () => {

    setIsModalOpen(false);

    setShowEmailLogin(false);

  };



  const handleOpenModal = () => {

    setIsModalOpen(true);

  };



  const handleEmailLogin = (email, password) => {

    console.log('E-posta ile giriş yapılıyor:', email, password);

    setIsAuthenticated(true);

    setShowEmailLogin(false);

  };



  const shouldShowMainHeader = () => {

    const loginHeaderPages = [

      '/dashboard',

      '/new-story',

      '/edit-story',

      '/my-stories',

      '/profile',

      '/notifications',

      '/inbox',

      '/library',

      '/settings',

      '/discover',

      '/story-details',

      '/preview',

      '/book',

      '/community',

      '/category',

      '/read',

      '/search',

      '/search-results',

    ];



    return !loginHeaderPages.some(page => location.pathname.startsWith(page));

  };



  const showFooter = location.pathname === '/' && !isAuthenticated;



  return (

    <div className="App">

      {shouldShowMainHeader() ? <Header isLoggedIn={isAuthenticated} /> : <HeaderLogIn />}



      <main className="content-wrapper">

        <Routes>

          <Route path="/" element={<Home />} />

          <Route path="/read/:bookId/:chapterId" element={<BookReader />} />

          <Route path="/new-story" element={<NewStory />} />

          <Route path="/edit-story" element={<EditStory />} />

          <Route path="/my-stories" element={<MyStories />} />

          <Route path="/resetpassword" element={<ResetPassword />} />

          <Route path="/reset-password/:token" element={<NewPassword />} />

          <Route

            path="/login"

            element={

              <>

                {!showEmailLogin && !isModalOpen && (

                  <AuthModal

                    type={authType}

                    onClose={handleCloseModal}

                    onSwitchAuthType={handleSwitchAuthType}

                    onOpenModal={handleOpenModal}

                  />

                )}

                {isModalOpen && (

                  <AuthModal

                    type={authType}

                    onClose={handleCloseModal}

                    onSwitchAuthType={handleSwitchAuthType}

                    onAuthenticated={() => setIsAuthenticated(true)}

                  />

                )}

                {showEmailLogin && (

                  <EmailLogin

                    onLogin={handleEmailLogin}

                    onBack={() => setShowEmailLogin(false)}

                  />

                )}

              </>

            }

          />

          <Route path="/edit" element={<EditStory />} />

          <Route path="/preview" element={<StoryPreview />} />

          <Route path="/story-details/:storyId" element={<StoryDetails />} />

          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/category/:categoryId" element={<CategoryPage />} />

          <Route path="/profile/:userId" element={<Profile />} />

          <Route path="/notifications" element={<Notifications />} />

          <Route path="/inbox" element={<InBox />} />

          <Route path="/library" element={<Library />} />

          <Route path="/book/:bookId" element={<Book />} />

          <Route path="/settings" element={<Settings />} />

          <Route path="/discover" element={<Discover />} />

          <Route path="/search" element={<Search categories={categories} />} />

          <Route path="/search-results" element={<SearchResults />} />

          <Route path="/community/:profileUserId" element={<Community />} />

          <Route path="/agreements" element={<Agreements />} />

        </Routes>

      </main>

    </div>

  );

}



function App() {

  return (

    <Router>

      <WebSocketProvider>

        <AppContentWrapper />

      </WebSocketProvider>

    </Router>

  );

}



export default App;
